module.exports = __webpack_public_path__ + "static/media/close.c547ff9a.svg";